import React from 'react';

import { CircleSpinnerOverlay  } from 'react-spinner-overlay'

export const LoadingOverlay = (props: any) => {
  const loading = props.loading ?? true

  return (
    <React.Fragment>
        <CircleSpinnerOverlay zIndex={2000} loading={loading}　color="#ffae00" />
    </React.Fragment>
  )


}





